import React from "react";
import { INSTAGRAM_URL, YOUTUBE_URL } from "../../data/content";
import Logo from "./Logo";

const FOOTER_LINKS = [
  { id: "instagram", label: "Instagram", url: INSTAGRAM_URL },
  { id: "youtube", label: "YouTube", url: YOUTUBE_URL },
];

function FooterCopyright() {
  return <p>© 2026 Blanktjern Coaching · Trondheim, Norway</p>;
}

function FooterLinks() {
  return (
    <div className="footer-links">
      {FOOTER_LINKS.map((link) => (
        <a key={link.id} href={link.url} target="_blank" rel="noopener noreferrer">
          {link.label}
        </a>
      ))}
    </div>
  );
}

export default function SiteFooter() {
  return (
    <footer>
      <div style={{ display: "inline-flex", alignItems: "center", marginBottom: 14, opacity: 0.7 }}>
        <Logo variant="light" size="sm" />
      </div>
      <FooterCopyright />
      <FooterLinks />
    </footer>
  );
}
